export AllAssigned from '@3plearning/3p-teacheradmin-assets/assets/icons/ico_all_assigned.svg';
export Rocket from '@3plearning/3p-teacheradmin-assets/assets/icons/ico_rocket.svg';
export DownArrow from '@3plearning/3p-teacheradmin-assets/assets/icons/arrow_down.svg';
export UpArrow from '@3plearning/3p-teacheradmin-assets/assets/icons/arrow_up.svg';
export Question from '@3plearning/3p-teacheradmin-assets/assets/icons/ico_question.svg';
export Submitted from '@3plearning/3p-teacheradmin-assets/assets/icons/ico_dot.svg';
export Reviewed from '@3plearning/3p-teacheradmin-assets/assets/icons/ico_tick.svg';
export MessageBubble from '@3plearning/3p-teacheradmin-assets/assets/icons/ico_question_blank.svg';
export Forward from '@3plearning/3p-teacheradmin-assets/assets/icons/icon_forward.svg';
export Back from '@3plearning/3p-teacheradmin-assets/assets/icons/icon_back.svg';
export PreviewIcon from '@3plearning/3p-teacheradmin-assets/assets/icons/icon_present.svg';
export NotesIcon from '@3plearning/3p-teacheradmin-assets/assets/icons/icon_teach_notes.svg';
export DropdownIcon from '@3plearning/3p-teacheradmin-assets/assets/icons/icon_dropdown.svg';
export SearchIcon from '@3plearning/3p-teacheradmin-assets/assets/icons/icon_search.svg';
export FilterIcon from '@3plearning/3p-teacheradmin-assets/assets/icons/icon_filter.svg';
export FilterOutlineIcon from '@3plearning/3p-teacheradmin-assets/assets/icons/icon_filter_outline.svg';
export SelectStudentIcon from '@3plearning/3p-teacheradmin-assets/assets/icons/ico_select.svg';
export StudentIcon from '@3plearning/3p-teacheradmin-assets/assets/assign/icons/ico_student.svg';
export ParticipationIcon from '@3plearning/3p-teacheradmin-assets/assets/icons/ico_participation.svg';
export FilterDefault from '@3plearning/3p-teacheradmin-assets/assets/UPF/icons/filter_default.svg';
export Voluntary from '@3plearning/3p-teacheradmin-assets/assets/icons/ico_voluntary.svg';
export LearningGaps from '@3plearning/3p-teacheradmin-assets/assets/icons/ico_learninggaps.svg';
export PdfIcon from '@3plearning/3p-teacheradmin-assets/assets/icons/icon_pdf.svg';


// UPF specific icons
export Visible from '@3plearning/3p-teacheradmin-assets/assets/UPF/icons/ico_visible.svg';
export Crown from '@3plearning/3p-teacheradmin-assets/assets/UPF/icons/ico_crown.svg';
export CrownMedium from '@3plearning/3p-teacheradmin-assets/assets/UPF/icons/ico_crown_medium.svg';
export Info from '@3plearning/3p-teacheradmin-assets/assets/UPF/icons/ico_info.svg';
export StandardDropdown from '@3plearning/3p-teacheradmin-assets/assets/UPF/icons/btn_standard_dropdown.svg';
export Step1 from '@3plearning/3p-teacheradmin-assets/assets/UPF/icons/ico_step_1.svg';
export Step2 from '@3plearning/3p-teacheradmin-assets/assets/UPF/icons/ico_step_2.svg';
export Step3 from '@3plearning/3p-teacheradmin-assets/assets/UPF/icons/ico_step_3.svg';
export Step4 from '@3plearning/3p-teacheradmin-assets/assets/UPF/icons/ico_step_4.svg';
export Step5 from '@3plearning/3p-teacheradmin-assets/assets/UPF/icons/ico_step_5.svg';
export QuestionMarkLeft from '@3plearning/3p-teacheradmin-assets/assets/UPF/images/img_question_marks_left.svg';
export QuestionMarkRight from '@3plearning/3p-teacheradmin-assets/assets/UPF/images/img_question_marks_right.svg';
export CollapseButton from '@3plearning/3p-teacheradmin-assets/assets/UPF/icons/btn_collapse_column.svg';
export ExpandButton from '@3plearning/3p-teacheradmin-assets/assets/UPF/icons/ico_expand_large.svg';
export Collapse from '@3plearning/3p-teacheradmin-assets/assets/UPF/icons/ico_collapse_dark.svg';
export Expand from '@3plearning/3p-teacheradmin-assets/assets/UPF/icons/ico_expand_dark.svg';
export Bolt from '@3plearning/3p-teacheradmin-assets/assets/icons/ico_bolt.svg';
export Select from '@3plearning/3p-teacheradmin-assets/assets/icons/ico_select.svg';
export Cross from '@3plearning/3p-teacheradmin-assets/assets/icons/icon_cross.svg';

export Gem1 from '@3plearning/3p-teacheradmin-assets/assets/UPF/icons/ico_gem_1.svg';
export Gem2 from '@3plearning/3p-teacheradmin-assets/assets/UPF/icons/ico_gem_2.svg';
export Gem3 from '@3plearning/3p-teacheradmin-assets/assets/UPF/icons/ico_gem_3.svg';
export Gem4 from '@3plearning/3p-teacheradmin-assets/assets/UPF/icons/ico_gem_4.svg';
export Gem5 from '@3plearning/3p-teacheradmin-assets/assets/UPF/icons/ico_gem_5.svg';
export PreviewInfoIcon from '@3plearning/3p-teacheradmin-assets/assets/UPF/icons/ico_info.svg';
export PreviewDemoIcon from '@3plearning/3p-teacheradmin-assets/assets/UPF/icons/ico_preview.svg';
export AssignIcon from '@3plearning/3p-teacheradmin-assets/assets/UPF/icons/ico_assign.svg';
export IconAssignLater from '@3plearning/3p-teacheradmin-assets/assets/icons/ico_assignlater.svg';
export UnAssignIcon from '@3plearning/3p-teacheradmin-assets/assets/UPF/icons/ico_unassign.svg';
export UnassignAll from '@3plearning/3p-teacheradmin-assets/assets/icons/ico_unassignall.svg';
export ReassignIconDark from '@3plearning/3p-teacheradmin-assets/assets/icons/ico_reassign.svg';
export UnassignIconDark from '@3plearning/3p-teacheradmin-assets/assets/icons/ico_unassign.svg';
export VideoHelp from '@3plearning/3p-teacheradmin-assets/assets/icons/ico_vidhelp.svg';


export IconLocked from '@3plearning/3p-teacheradmin-assets/assets/icons/icon_locked_color.svg';
export IconUnlocked from '@3plearning/3p-teacheradmin-assets/assets/icons/icon_unlocked_color.svg';
export LockIcon from '@3plearning/3p-teacheradmin-assets/assets/icons/icon_lock.svg';
export UnlockIcon from '@3plearning/3p-teacheradmin-assets/assets/icons/icon_unlock.svg';



// WEBPACK FOOTER //
// ./helpers/icon-dictionary.js